import { ListingConfig } from "./index";

export const TankReadingConfig: ListingConfig = {
  reportConfig: {
    reportId: "Ty67uDRHQ9tsDOXsBNKV",
  },
  // Defines the primary date field in the 'capturedTankReading' collection for date range filtering
  dateField: "transactionDate", // Assuming 'transactionDate' is the correct field for date filtering
  filterConfig: [
    {
      fieldIdToFilter: "documentNumber",
      label: "Document #",
      paramName: "documentNumber",
      placeholder: "e.g. T000-000-001",
      // No sourceCollection indicates this is a text input filter
    },
    {
      // Field in the 'capturedTankReading' collection (templateName) to filter on
      fieldIdToFilter: "tankId", 
      label: "Tank", // Label for the Select dropdown
      paramName: "tank", // URL query parameter name
      sourceCollection: "tanks", // Firestore collection to fetch options from
      // sourceFieldForValue: "id", // Implicitly use document ID as the value
      sourceFieldForLabel: "name", // Field in 'tanks' documents for the dropdown label (e.g., tank name)
                                  // Adjust "name" if your tanks collection uses a different field for the display label.
    }
  ],
  fieldConfig: {
    deviceCaptured: {
      label: "Device capture date",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "DATE",
    },
    tankName: { // This field likely comes from a denormalized 'tankId' lookup or is directly on the reading
      label: "Tank name",
      tableRank: 2,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    levelLitres: {
      label: "Tank level",
      tableRank: 3,
      detailsRank: 2,
      editable: true,
      type: "NUMBER",
    },
    signedBy: {
      label: "Signed by",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    tankSizeLitres: {
      label: "Tank size",
      tableRank: 6,
      detailsRank: -1,
      editable: false,
      type: "NUMBER",
    },
    signedByImage: {
      label: "Signature",
      tableRank: -1,
      detailsRank: 7,
      editable: false,
      type: "IMAGE",
    },
    dipReadingPhoto: {
      label: "Dip reading picture",
      tableRank: -1,
      detailsRank: 5,
      editable: false,
      type: "IMAGE",
    },
    tankIsMobile: {
      label: "Tank is mobile",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    },
    tankFuelType: {
      label: "Fuel type",
      tableRank: 5,
      detailsRank: 10,
      editable: false,
      type: "STRING",
    },
    createdBy: {
      label: "Creator",
      tableRank: 4,
      detailsRank: 11,
      editable: false,
      type: "STRING",
    },
    gpsLocation: {
      label: "Location",
      tableRank: -1,
      detailsRank: 12,
      editable: false,
      type: "COORDINATE",
    },
    isModified: {
      label: "Entry modified",
      tableRank: -1,
      detailsRank: 13,
      editable: false,
      type: "BOOLEAN",
    },
    companyId: { // Ensure this field exists if your queries rely on it implicitly
      label: "Company ID",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    id: { // Document ID of the tank reading itself
      label: "ID",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    // Ensure 'tankId' exists in your 'capturedTankReading' documents for the filter to work
    tankId: { 
      label: "Tank",
      tableRank: -1,
      detailsRank: 3,
      editable: true,
      type: "SELECT",
      sourceCollection: "tanks",
      sourceFieldForLabel: "name",
      adjacentFields: {
        tankFuelType: "fuelType",
        tankIsMobile: "mobileTank",
        tankName: "name",
        tankSizeLitres: "size"
      }
    },
    documentNumber: {
      label: "Document #",
      tableRank: 3, // Adjusted from 3 to 1 to be more prominent if it's a primary identifier
      detailsRank: 100,
      editable: false,
      type: "STRING",
    },
    syncCompleted: {
      label: "--INTERNAL--",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    },
    receivedOnServer: {
      label: "--INTERNAL--",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "DATE",
    },
    transactionDate: { // This is the dateField
      label: "Date",
      tableRank: 0, // Made it 0 to be the first column
      detailsRank: 0,
      editable: true,
      type: "DATE",
    },
    transactionReviewed: {
      label: "Reviewed",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    }
  }
};
